const currencyFormatter = (number, withSymbol = true) => {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  })
    .format(number)
    .substring(withSymbol ? 0 : 1);
};
export default currencyFormatter;
